/* Pure Wine: Tasting Schedule page (sections/pw-tastings.liquid).
   Works out the upcoming tasting dates in New York time from the standing schedule, merges in the
   optional "Tasting" blocks and the "No tasting" dates, and hides anything that is over.
   To preview another moment, add ?pw_now=2026-11-24T18:30 to the page address. */
(function () {
  'use strict';
  var TZ = 'America/New_York';
  var MONTHS = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'];
  var WEEKDAYS = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function key(y, m, d) { return y + '-' + pad(m) + '-' + pad(d); }
  function fromKey(k) { var p = k.split('-'); return new Date(Date.UTC(+p[0], +p[1] - 1, +p[2], 12)); }
  function toKey(dt) { return key(dt.getUTCFullYear(), dt.getUTCMonth() + 1, dt.getUTCDate()); }
  function addDays(k, n) { var dt = fromKey(k); dt.setUTCDate(dt.getUTCDate() + n); return toKey(dt); }
  function dayDiff(a, b) { return Math.round((fromKey(a) - fromKey(b)) / 86400000); }
  function valid(y, m, d) { var dt = new Date(Date.UTC(y, m - 1, d, 12)); return dt.getUTCFullYear() === y && dt.getUTCMonth() === m - 1 && dt.getUTCDate() === d; }
  function hm(str) { var p = String(str || '').split(':'); return (+p[0] || 0) * 60 + (+p[1] || 0); }

  function nyParts(ms) {
    try {
      var f = new Intl.DateTimeFormat('en-US', { timeZone: TZ, year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', hourCycle: 'h23' });
      var o = {};
      f.formatToParts(new Date(ms)).forEach(function (p) { o[p.type] = p.value; });
      return { key: key(+o.year, +o.month, +o.day), minutes: (+o.hour % 24) * 60 + (+o.minute) };
    } catch (e) {
      var d = new Date(ms);
      return { key: key(d.getFullYear(), d.getMonth() + 1, d.getDate()), minutes: d.getHours() * 60 + d.getMinutes() };
    }
  }

  function nearestYear(m, d, today) {
    var ty = +today.slice(0, 4), best = null, gap = Infinity;
    [ty - 1, ty, ty + 1].forEach(function (y) {
      if (!valid(y, m, d)) return;
      var g = Math.abs(dayDiff(key(y, m, d), today));
      if (g < gap) { gap = g; best = y; }
    });
    return best;
  }

  /* Accepts 2026-10-01, 10/1/2026, 10/1/26, 10/1, Oct 1, October 1 2026, Thu Oct 1. Returns YYYY-MM-DD or null. */
  function parseDate(raw, today) {
    if (!raw) return null;
    var s = String(raw).trim().toLowerCase().replace(/,/g, ' ').replace(/\s+/g, ' ');
    var sp = s.indexOf(' ');
    if (sp > 2) {
      var first = s.slice(0, sp).replace(/\.$/, '');
      if (WEEKDAYS.some(function (w) { return w.indexOf(first) === 0; })) s = s.slice(sp + 1);
    }
    var y, m, d, x;
    if ((x = s.match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/))) { y = +x[1]; m = +x[2]; d = +x[3]; }
    else if ((x = s.match(/^(\d{1,2})\/(\d{1,2})(?:\/(\d{4}|\d{2}))?$/))) { m = +x[1]; d = +x[2]; y = x[3] ? +x[3] : null; if (y !== null && y < 100) y += 2000; }
    else if ((x = s.match(/^([a-z]{3,9})\.? (\d{1,2})(?:st|nd|rd|th)?(?: (\d{4}))?$/))) {
      m = 0;
      MONTHS.forEach(function (name, i) { if (name.indexOf(x[1]) === 0 || (x[1] === 'sept' && i === 8)) m = i + 1; });
      d = +x[2]; y = x[3] ? +x[3] : null;
    } else return null;
    if (!m) return null;
    if (y === null || y === undefined) y = nearestYear(m, d, today);
    if (!y || !valid(y, m, d)) return null;
    return key(y, m, d);
  }

  /* Accepts "6 to 8pm", "6:30-8pm", "11am to 1pm". Returns minutes from midnight or null. */
  function parseRange(raw) {
    if (!raw) return null;
    var x = String(raw).toLowerCase().match(/(\d{1,2})(?::(\d{2}))?\s*(am|pm)?\s*(?:to|until|-|\u2013|\u2014)\s*(\d{1,2})(?::(\d{2}))?\s*(am|pm)/);
    if (!x) return null;
    var end = ((+x[4] % 12) + (x[6] === 'pm' ? 12 : 0)) * 60 + (+x[5] || 0);
    var sh = +x[1] % 12, sm = +x[2] || 0;
    if (x[3]) sh += x[3] === 'pm' ? 12 : 0;
    else { sh += x[6] === 'pm' ? 12 : 0; if (sh * 60 + sm >= end) sh -= 12; }
    var start = sh * 60 + sm;
    if (start < 0 || start >= end) return null;
    return { start: start, end: end };
  }

  function buildRows(cfg, now) {
    var today = now.key, rows = [], notes = { bad: [], past: 0 };
    var std = { start: hm(cfg.start), end: hm(cfg.end) };
    var days = cfg.days || [];
    var closed = {}, events = {};

    String(cfg.closed || '').split(/\n/).forEach(function (line) {
      line = line.trim();
      if (!line) return;
      var x = line.match(/^(\d{4}-\d{1,2}-\d{1,2}|\d{1,2}\/\d{1,2}(?:\/\d{2,4})?)\s*[:\u2013-]?\s*(.*)$/);
      var k = x && parseDate(x[1], today);
      if (k) closed[k] = x[2] || ''; else notes.bad.push(line);
    });

    (cfg.events || []).forEach(function (ev) {
      if (!ev || !(ev.date || ev.title || ev.text)) return;
      var k = parseDate(ev.date, today);
      if (!k) { notes.bad.push(ev.date || ('no date on "' + (ev.title || 'untitled') + '"')); return; }
      var range = ev.time ? parseRange(ev.time) : std;
      if (k < today || (k === today && range && now.minutes >= range.end)) { notes.past++; return; }
      (events[k] = events[k] || []).push({ ev: ev, range: range });
    });

    var count = 0, max = Math.max(1, +cfg.count || 6);
    for (var i = 0; i < 200 && count < max && days.length; i++) {
      var k = addDays(today, i);
      if (days.indexOf(fromKey(k).getUTCDay()) === -1) continue;
      if (i === 0 && now.minutes >= std.end) continue;
      if (events[k]) { count++; continue; }
      if (Object.prototype.hasOwnProperty.call(closed, k)) { rows.push({ key: k, closed: true, note: closed[k], title: cfg.closedLabel || 'No tasting' }); continue; }
      rows.push({ key: k, range: std, timeLabel: cfg.timeLabel, title: cfg.title, text: cfg.text || '' });
      count++;
    }
    Object.keys(events).forEach(function (k) {
      events[k].forEach(function (e) {
        rows.push({
          key: k, range: e.range, timeLabel: e.ev.time || cfg.timeLabel, title: e.ev.title || cfg.title, text: e.ev.text || '',
          linkLabel: e.ev.linkLabel, linkUrl: e.ev.linkUrl, special: days.indexOf(fromKey(k).getUTCDay()) === -1
        });
      });
    });
    rows.sort(function (a, b) {
      if (a.key !== b.key) return a.key < b.key ? -1 : 1;
      return ((a.range && a.range.start) || 0) - ((b.range && b.range.start) || 0);
    });
    rows.forEach(function (r) {
      if (r.closed) return;
      if (r.key === today) r.pill = r.range && now.minutes >= r.range.start ? 'Pouring now' : 'Today';
      else if (r.key === addDays(today, 1)) r.pill = 'Tomorrow';
    });
    return { rows: rows, notes: notes };
  }

  /* Calendar links */
  function nyToUtc(k, minutes) {
    var p = k.split('-'), h = Math.floor(minutes / 60), mi = minutes % 60, offsets = [4, 5];
    for (var i = 0; i < offsets.length; i++) {
      var ms = Date.UTC(+p[0], +p[1] - 1, +p[2], h + offsets[i], mi);
      var q = nyParts(ms);
      if (q.key === k && q.minutes === minutes) return ms;
    }
    return Date.UTC(+p[0], +p[1] - 1, +p[2], h + 5, mi);
  }
  function utcStamp(ms) { return new Date(ms).toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, ''); }
  function localStamp(k, minutes) { return k.replace(/-/g, '') + 'T' + pad(Math.floor(minutes / 60)) + pad(minutes % 60) + '00'; }
  function icsText(v) { return String(v || '').replace(/\\/g, '\\\\').replace(/;/g, '\\;').replace(/,/g, '\\,').replace(/\r?\n/g, '\\n'); }

  function calendarLinks(row, cfg) {
    if (!row.range) return null;
    var name = row.title + (cfg.shopName ? ' at ' + cfg.shopName : '');
    var details = (row.text ? row.text + '\n\n' : '') + (cfg.pageUrl || '');
    var google = 'https://calendar.google.com/calendar/render?action=TEMPLATE' +
      '&text=' + encodeURIComponent(name) +
      '&dates=' + localStamp(row.key, row.range.start) + '/' + localStamp(row.key, row.range.end) +
      '&ctz=' + encodeURIComponent(TZ) +
      '&details=' + encodeURIComponent(details) +
      '&location=' + encodeURIComponent(cfg.location || '');
    var ics = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//Pure Wine//Tasting Schedule//EN', 'BEGIN:VEVENT',
      'UID:tasting-' + row.key + '-' + row.range.start + '@purewinenyc.com',
      'DTSTAMP:' + utcStamp(Date.now()),
      'DTSTART:' + utcStamp(nyToUtc(row.key, row.range.start)),
      'DTEND:' + utcStamp(nyToUtc(row.key, row.range.end)),
      'SUMMARY:' + icsText(name),
      'LOCATION:' + icsText(cfg.location),
      'DESCRIPTION:' + icsText(details),
      'END:VEVENT', 'END:VCALENDAR'].join('\r\n');
    return { google: google, ics: 'data:text/calendar;charset=utf-8,' + encodeURIComponent(ics), file: 'pure-wine-tasting-' + row.key + '.ics' };
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { parseDate: parseDate, parseRange: parseRange, buildRows: buildRows, calendarLinks: calendarLinks, nyParts: nyParts, nyToUtc: nyToUtc };
  }
  if (typeof document === 'undefined') return;

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text !== undefined && text !== null) n.textContent = text;
    return n;
  }
  function fmt(k, opts) { opts.timeZone = 'UTC'; return fromKey(k).toLocaleDateString('en-US', opts); }

  function renderRow(row, cfg) {
    var li = el('li', 'pw-taste__row' + (row.closed ? ' pw-taste__row--closed' : '') + (row.pill && row.pill !== 'Tomorrow' ? ' pw-taste__row--today' : '') + (row.special ? ' pw-taste__row--special' : ''));
    var date = el('div', 'pw-taste__date');
    date.setAttribute('aria-hidden', 'true');
    date.appendChild(el('span', 'pw-taste__dow', fmt(row.key, { weekday: 'short' })));
    date.appendChild(el('span', 'pw-taste__day', fmt(row.key, { day: 'numeric' })));
    date.appendChild(el('span', 'pw-taste__mon', fmt(row.key, { month: 'short' })));
    li.appendChild(date);

    var body = el('div', 'pw-taste__body');
    var when = el('p', 'pw-taste__when');
    var time = el('time', null, fmt(row.key, { weekday: 'long', month: 'long', day: 'numeric' }));
    time.setAttribute('datetime', row.key);
    when.appendChild(time);
    if (!row.closed && row.timeLabel) when.appendChild(el('span', null, row.timeLabel));
    if (row.pill) when.appendChild(el('span', 'pw-taste__pill', row.pill));
    body.appendChild(when);
    body.appendChild(el('h3', 'pw-taste__title', row.closed && row.note ? row.title + ': ' + row.note : row.title));
    if (row.text) body.appendChild(el('p', 'pw-taste__text', row.text));
    if (row.linkUrl && row.linkLabel) {
      var more = el('p', 'pw-taste__more');
      var a = el('a', null, row.linkLabel);
      a.href = row.linkUrl;
      more.appendChild(a);
      body.appendChild(more);
    }
    li.appendChild(body);

    var cal = !row.closed && cfg.calendar ? calendarLinks(row, cfg) : null;
    if (cal) {
      var side = el('div', 'pw-taste__side');
      side.appendChild(el('span', null, 'Add to calendar'));
      var links = el('div');
      var g = el('a', null, 'Google');
      g.href = cal.google; g.target = '_blank'; g.rel = 'noopener';
      g.setAttribute('aria-label', 'Add ' + fmt(row.key, { month: 'long', day: 'numeric' }) + ' to Google Calendar');
      var i = el('a', null, 'Apple or Outlook');
      i.href = cal.ics; i.setAttribute('download', cal.file);
      i.setAttribute('aria-label', 'Download a calendar file for ' + fmt(row.key, { month: 'long', day: 'numeric' }));
      links.appendChild(g); links.appendChild(i);
      side.appendChild(links);
      li.appendChild(side);
    }
    return li;
  }

  function currentMoment() {
    var x = (window.location.search || '').match(/[?&]pw_now=(\d{4})-(\d{1,2})-(\d{1,2})(?:T(\d{1,2}):(\d{2}))?/);
    if (x && valid(+x[1], +x[2], +x[3])) return { key: key(+x[1], +x[2], +x[3]), minutes: (+x[4] || 0) * 60 + (+x[5] || 0) };
    return nyParts(Date.now());
  }

  function init(root) {
    var list = root.querySelector('[data-pw-taste-list]');
    var cfgEl = root.querySelector('[data-pw-taste-config]');
    if (!list || !cfgEl) return;
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    var out = buildRows(cfg, currentMoment());
    if (out.rows.length) {
      var frag = document.createDocumentFragment();
      out.rows.forEach(function (r) { frag.appendChild(renderRow(r, cfg)); });
      list.textContent = '';
      list.appendChild(frag);
    }
    var note = root.querySelector('[data-pw-taste-note]');
    if (note && window.Shopify && window.Shopify.designMode) {
      var lines = [];
      out.notes.bad.forEach(function (b) { lines.push('Could not read this date: ' + b + '. Type dates like 2026-10-01, 10/1/2026, or Oct 1.'); });
      if (out.notes.past) lines.push(out.notes.past + (out.notes.past === 1 ? ' past tasting is' : ' past tastings are') + ' hidden from the page. You can delete the block' + (out.notes.past === 1 ? '' : 's') + '.');
      if (lines.length) { note.textContent = 'Only you see this note, in the theme editor.\n' + lines.join('\n'); note.hidden = false; }
    }
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-pw-taste]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target && e.target.querySelector ? e.target.querySelector('[data-pw-taste]') : null;
    if (root) init(root);
  });
})();